<div>
  <form [formGroup]="unitForm">
    <mat-card>
      <mat-card-content>
        <h4>Add Unit</h4>
        <mat-form-field class="mat-width">
          <mat-label>Unit Name</mat-label>
          <input matInput formControlName="name" placeholder="Enter Unit Name" autocomplete="off" required>
          @if (name.touched && name.invalid && name.hasError('required')) {
            <mat-error>Name is required</mat-error>
          }
        </mat-form-field>
          <mat-form-field class="mat-width">
            <mat-label>Unit Code</mat-label>
            <input matInput formControlName="code" placeholder="Enter Unit Code" autocomplete="off" required>
            <mat-error *ngIf="code.touched && code.invalid && code.hasError('required')">Unit Code is required</mat-error>
          </mat-form-field>
        <mat-card-actions>
          <button mat-button color="cancel" (click)="cancel()">CANCEL</button>
          <button mat-button color="primary" (click)="save()" [disabled]="editPermission">SAVE</button>
        </mat-card-actions>
      </mat-card-content>
    </mat-card>
  </form>
</div>
